import {
  route,
} from '@app/Routing/helpers'

const TicketList = () => import('@app/Staff/Ticket/View')
const AddTicket = () => import('@app/Staff/Ticket/Add')
const TicketDetail = () => import('@app/Staff/Ticket/Detail')

const MODEL = 'ticket'

const BASE = `${MODEL}`
const u = url => BASE + url

const LIST = u('/')
const ADD_POSITIVE = u('/add-positive/')
const ADD_NEGATIVE = u('/add-negative/')
const DETAIL = u('/edit/:id/')

export const TICKET_PREFIX = `${MODEL}:`
const p = name => TICKET_PREFIX + name

export const TICKET_BASE_NAME = p('base')
export const TICKET_LIST_NAME = p('list')
export const TICKET_DETAIL_NAME = p('detail')
export const ADD_POSITIVE_TICKET_NAME = p('add-positive')
export const ADD_NEGATIVE_TICKET_NAME = p('add-negative')

export function createRoutes() {
  return [
    route(LIST, TicketList, TICKET_LIST_NAME, {
      meta: { hideVisitCard: true },
    }),
    route(ADD_POSITIVE, AddTicket, ADD_POSITIVE_TICKET_NAME, {
      meta: { hideVisitCard: true, layout: 'ticket-layout' },
    }),
    route(ADD_NEGATIVE, AddTicket, ADD_NEGATIVE_TICKET_NAME, {
      meta: { hideVisitCard: true, layout: 'ticket-layout' },
    }),
    route(DETAIL, TicketDetail, TICKET_DETAIL_NAME, {
      meta: { hideVisitCard: true },
    }),
  ]
}
